import { useChatExamples } from './queries'
import styles from './studio.module.css'

export function ChatExamples() {
  const list = useChatExamples()
  const items = list.data?.items ?? []
  return (
    <details className={styles.chatExamples}>
      <summary>Сохранённые эталоны диалога ({list.data?.total ?? 0})</summary>
      {list.isError && <p className="error-box">Не удалось загрузить эталоны.</p>}
      {items.map((item) => (
        <article key={item.id} className={styles.example}>
          <div className={styles.exampleHead}>
            <span className="muted">{item.prompt_version ?? '—'}</span>
            <span className="muted">{new Date(item.created_at).toLocaleDateString('ru-RU')}</span>
          </div>
          <div className="transcript muted">{item.input.split('\n').slice(1).join('\n')}</div>
          <div className="transcript">Мила: {item.expert_output}</div>
        </article>
      ))}
    </details>
  )
}
